import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {HInput, HTextarea, passParamsThrough, DSelect, HMaskedInput, HCheckbox} from '../../../validation/HForm';
import {
  getEmployees,
  getDepartmentLeader,
  getChiefAccountant,
  getAccountant,
  getSeniorCommodityExpert,
  getGoodsSpecialist,
} from '../../../redux/actions/handbookAction';

const DepartmentModalAdd = (props) => {
  const { departmentLeader, chiefAccountant, accountant, seniorCommodityExpert, goodsSpecialist } =
    useSelector(({ handbook }) => handbook);
  const { accessFeatures } = useSelector(({ user }) => user);
  const dispatch = useDispatch();

  const placeholder = 'Введите имя';

  useEffect(() => {
    dispatch(getEmployees(''));
  }, [dispatch]);

  const handleOptionsDepartmentLeader = (e, action) => {
    if (action.action === 'input-change') dispatch(getDepartmentLeader(e));
  };

  const handleOptionsChiefAccountant = (e, action) => {
    if (action.action === 'input-change') dispatch(getChiefAccountant(e));
  };

  const handleOptionsAccountant = (e, action) => {
    if (action.action === 'input-change') dispatch(getAccountant(e));
  };

  const handleOptionsSeniorCommodityExpert = (e, action) => {
    if (action.action === 'input-change') dispatch(getSeniorCommodityExpert(e));
  };

  const handleOptionsGoodsSpecialist = (e, action) => {
    if (action.action === 'input-change') dispatch(getGoodsSpecialist(e));
  };

  return passParamsThrough(
    <fieldset>
      <div className="form-row">
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="departmentDataName">
              Название
            </label>
            <div className="form-element-data">
              <HInput h="true" className="input" type="text" name="name" id="departmentDataName"/>
            </div>
          </div>
        </div>
        
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="departmentDataNumber">
              Номер
            </label>
            <div className="form-element-data number">
              <HInput
                  h="true"
                  className="input"
                  type="text"
                  name="number"
                  id="departmentDataNumber"
              />
            </div>
          </div>
        </div>
        {accessFeatures["cash_box.main.enable"] && <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="isMain">
              Дирекция
            </label>
            <div className="form-element-data number">
              <HCheckbox
                h="true"
                name="isMain"
                className="input"
                id="isMain"
                defaultValue={props.isMain}
              />
            </div>
          </div>
        </div>}
        {accessFeatures["cash_box.auto.enable"] && <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="autoCashBox">
              Автоломбард
            </label>
            <div className="form-element-data number">
              <HCheckbox
                h="true"
                name="autoCashBox"
                className="input"
                id="autoCashBox"
                defaultValue={props.autoCashBox}
              />
            </div>
          </div>
        </div>}
      </div>
      <div className="form-row">
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="departmentPhone">
              Гор. телефон
            </label>
            <div className="form-element-data">
              <HInput
                  h="true"
                  className="input"
                  type="phone"
                  name="phone"
                  id="departmentDataBossName"
              />
            </div>
          </div>
        </div>
        {
          accessFeatures['cashbox.mobile'] &&
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="departmentPhone">
                  Моб. телефон
                </label>
                <div className="form-element-data">
                  <HMaskedInput
                      h="true"
                      className="input"
                      type="phone"
                      name="mobilePhone"
                      mask="+375 99 999 99 99"
                      id="mobilePhone" />
                </div>
              </div>
            </div>
        }
      </div>
      <div className="form-row">
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="departmentDataCity">
              Город
            </label>
            <div className="form-element-data">
              <HInput h="true" className="input" type="text" name="city" id="departmentDataCity" />
            </div>
          </div>
        </div>
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="departmentDataStreetName">
              Улица
            </label>
            <div className="form-element-data">
              <HInput
                h="true"
                className="input"
                type="text"
                name="street"
                id="departmentDataStreetName"
              />
            </div>
          </div>
        </div>
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="departmentDataHomeNumber">
              Дом
            </label>
            <div className="form-element-data number">
              <HInput
                h="true"
                className="input"
                type="text"
                name="house"
                id="departmentDataHomeNumber"
              />
            </div>
          </div>
        </div>
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="departmentDataAddressPartNumber">
              Корпус
            </label>
            <div className="form-element-data number">
              <HInput
                h="true"
                className="input"
                type="text"
                name="building"
                id="departmentDataAddressPartNumber"
              />
            </div>
          </div>
        </div>
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="departmentOfficeNumber">
              Офис
            </label>
            <div className="form-element-data number">
              <HInput
                h="true"
                className="input"
                type="text"
                name="office"
                id="departmentOfficeNumber"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="form-element">
        <label className="form-element-label" htmlFor="departmentDataBossName">
          Руководитель
        </label>
        <div className="form-element-data combobox">
          <DSelect
            h="true"
            name="leaderId"
            options={departmentLeader}
            handleOptions={handleOptionsDepartmentLeader}
            isLoading={false}
            placeholder={placeholder}
          />
        </div>
      </div>
      <div className="form-element">
        <label className="form-element-label" htmlFor="departmentDataAccountantName">
          Главный бухгалтер
        </label>
        <div className="form-element-data combobox">
          <DSelect
            h="true"
            name="chiefAccountantId"
            options={chiefAccountant}
            handleOptions={handleOptionsChiefAccountant}
            isLoading={false}
            placeholder={placeholder}
          />
        </div>
      </div>
      <div className="form-element">
        <label className="form-element-label" htmlFor="departmentDataAccountantSecondaryName">
          Бухгалтер
        </label>
        <div className="form-element-data combobox">
          <DSelect
            h="true"
            name="accountantId"
            options={accountant}
            handleOptions={handleOptionsAccountant}
            isLoading={false}
            placeholder={placeholder}
          />
        </div>
      </div>
      <div className="form-element">
        <label className="form-element-label" htmlFor="departmentDataAccountantSecondaryName">
          Старший товаровед
        </label>
        <div className="form-element-data combobox">
          <DSelect
            h="true"
            name="seniorCommodityExpertId"
            options={seniorCommodityExpert}
            handleOptions={handleOptionsSeniorCommodityExpert}
            isLoading={false}
            placeholder={placeholder}
          />
        </div>
      </div>
      <div className="form-element">
        <label className="form-element-label" htmlFor="departmentDataAccountantSecondaryName">
          Товароведы
        </label>
        <div className="form-element-data combobox multi-select">
          <DSelect
            h="true"
            name="goodsSpecialistsIds"
            isMulti={true}
            options={goodsSpecialist}
            handleOptions={handleOptionsGoodsSpecialist}
            isLoading={false}
            placeholder={placeholder}
          />
        </div>
      </div>
      <div className="form-element">
        <label className="form-element-label" htmlFor="departmentAdditionalDescription">
          Дополнительная информация
        </label>
        <div className="form-element-data textarea">
          <HTextarea
            h="true"
            className="input"
            rows="4"
            cols="10"
            name="additionalInfo"
            id="departmentAdditionalDescription"
          />
        </div>
      </div>
    </fieldset>,
    props,
  );
};

export default DepartmentModalAdd;
